export default {
  methods: {
    addEscListener(event) {
      if (event.keyCode === 27) {
        this.$emit('click-esc');
      }
    }
  },

  mounted() {
    document.addEventListener('keyup', this.addEscListener);
  },

  beforeDestroy() {
    document.removeEventListener('keyup', this.addEscListener);
  }
};



// WEBPACK FOOTER //
// src/mixins/keyboard.js